import React from 'react';
import { PDFViewer } from '@react-pdf/renderer';
import { RootLayout } from './RootLayaout';

const PDFPreview = ({ data, type }) => {
    const isPF = type === 'PF';

    return (
        <div style={{ width: '100%', height: '100%' }}>
            <PDFViewer width="100%" height="100%" style={{ border: 'none' }}>
                <RootLayout data={data} isPF={isPF} />
            </PDFViewer>
        </div>
    );
};

export default PDFPreview;

